import React, { useState } from "react";
import styles from "./DestinationCardSmall.module.scss";
import {Modal} from "./Modal";
import DestinationExpanded from "./DestinationExpanded";
import {DestinationCardProps} from "../types/destination";

export const DestinationCardSmall: React.FC<DestinationCardProps> = ({destination}) => {
    const [open, setOpen] = useState<boolean>(false);

    return (
        <>
            <div
                className={styles.dcsCard}
                role="button"
                tabIndex={0}
                onClick={() => setOpen(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setOpen(true);
                    }
                }}
            >
                <div className={styles.dcsImg}><img src={destination.image} alt={destination.name} loading="lazy" /></div>
                <div className={styles.dcsBody}>
                    <div className={styles.dcsName}>{destination.name}</div>
                    <div className={styles.dcsCountry}>{destination.country}</div>
                    <div className={styles.dcsPrice}>From ${destination.price}</div>
                </div>
            </div>

            <Modal isOpen={open} onClose={() => setOpen(false)} size="page">
                <DestinationExpanded slug={destination?.slug} inModal />
            </Modal>
        </>
    )

}